export const RENTER_UPDATE_REVIEW = "RENTER_UPDATE_REVIEW"
export const RENTER_UPDATE_REVIEW_SUCCESSFUL = "RENTER_UPDATE_REVIEW_SUCCESSFUL"
export const RENTER_UPDATE_REVIEW_FAILED = "RENTER_UPDATE_REVIEW_FAILED"
export const RENTER_UPDATE_REVIEW_RESET = "RENTER_UPDATE_REVIEW_RESET"

